export const CommentWithFile = {
  Explanation: "explanation" as const,
  FilesToUpload: "filesToUpload" as const,
  PostWithoutPicture: "postWithoutPicture" as const,
  MarkAsResolved: "markAsResolved" as const,
}

